import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { ThingIcon } from "../icons";

export default {
  options: {
    group: "config",
    accessible: ({ user }) =>
      user.role === "admin" && user.permissions.indexOf("thing/list") !== -1,
  },
  icon: ThingIcon,
  list: List,
  edit: Edit,
  create: Create,
};
